var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tab[data-v-f3155bb0]{background-image:url(" + escape(require("../../images/tabs.png")) + ");width:100px;height:30px;padding:3px 8px 0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:#b7b0a9 !important;display:inline-block;text-decoration:none;text-align:center\n}\n.tab[data-v-f3155bb0]:hover,.tab.router-link-active[data-v-f3155bb0]{background-position-y:-30px;color:#d7ead9 !important\n}\n", ""]);

// exports
